import { apiUrl, requestJson } from './client'

export type AdminUser = {
  id: string
  email: string
  fullName: string
}

export const getCurrentAdmin = async (): Promise<AdminUser | null> => {
  const response = await fetch(`${apiUrl}/api/auth/me`, {
    credentials: 'include'
  })

  if (response.status === 401) {
    return null
  }

  if (!response.ok) {
    throw new Error(`Session check failed with status ${response.status}`)
  }

  const payload = (await response.json()) as { user: AdminUser }

  return payload.user
}

export const loginAdmin = async (input: {
  email: string
  password: string
}): Promise<AdminUser> => {
  const payload = await requestJson<{ user: AdminUser }>('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(input)
  })

  return payload.user
}

export const logoutAdmin = async (): Promise<void> => {
  await requestJson('/api/auth/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: '{}'
  })
}
